import * as React from "react";
import "./styles.scss"

interface AnomalyProps {
    errorMessage: string,
    expectedValue: number,
    receivedValue: number
}

export const Anomaly: React.FC<AnomalyProps> = ({errorMessage}) => {
    return <li>
        <p className={"anomaly-message"}>{errorMessage}</p>
    </li>
}